import { myListsEditListFormStyles } from "@insite/content-library/Widgets/MyLists/MyListsEditListForm";
import { actionStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsActions";
import { copyListFormStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsCopyListForm";
import {myListsDetailsOptionsStyles} from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsOptions"
import {productListStyles} from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductList"
import { productListLineStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductListLine";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import ChevronsUpDown from "@insite/mobius/Icons/ChevronsUpDown";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS } from "@tCentro/theme/design"
import { css } from "styled-components";

actionStyles.addListButton = {
    mergeCss: true,
    typographyProps: {
        weight: "bold",
        css: css`
            white-space: nowrap;
        `,
    },
    css: css`
        padding: 0 15px;
    `,
};

productListLineStyles.priceGridItem = {
    width: [12, 12, 12, 12, 5],
    printWidth: 5,
    css: css`
        flex-direction: column;
        > section {
            > div[class^="sc"] {
                > div[class^="sc"] {
                    padding: 0;
                    > span {
                        display: none;
}
                    h4 {
                        padding: 0px 2px;
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 24px;

                        span {
                            display: block;
                            margin-left: 0px !important;
                        }
                    }
                }
            }
            > span {
                display: none;
            }
        }

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    > section {
                        > div[class^="sc"] {
                            > div[class^="sc"] {
                                > span {
                                }
                                h4 {
                                    span {
                                        display: unset;
                                        margin-left: 8px !important;
                                    }
                                }
                            }
                        }
                        > span {
                            display: none;
                        }
                    }
                `,
                css`
                    > section {
                        > div[class^="sc"] {
                            > div[class^="sc"] {
                                > span {
                                }
                                h4 {
                                    span {
                                        display: unset;
                                        margin-left: 8px !important;
                                    }
                                }
                            }
                        }
                        > span {
                            display: none;
                        }
                    }
                `,
                css`
                    > section {
                        > div[class^="sc"] {
                            > div[class^="sc"] {
                                > span {
                                }
                                h4 {
                                    span {
                                        display: unset;
                                        margin-left: 8px !important;
                                    }
                                }
                            }
                        }
                        > span {
                            display: none;
                        }
                    }
                `,
                null,
                null,
            ])}
    `,
};

actionStyles.shareButton = {
    mergeCss: true,
    css: css`
        padding: 0 15px;
        margin-right: 10px;
    `,
    variant: "secondary",
}

actionStyles.editButton= {
    mergeCss: true,
    css: css`
        padding: 0 15px;
        margin-right: 10px;
    `,
    variant: "secondary",
}

actionStyles.scheduleButton= {
    mergeCss: true,
    css: css`
        padding: 0 15px;
        margin-right: 10px;
    `,
    variant: "secondary",
}

actionStyles.printButton= {
    mergeCss: true,
    css: css`
        padding: 0 15px;
        margin-right: 10px;
    `,
    variant: "secondary",
}

actionStyles.removeSelectedButton= {
    mergeCss: true,
    typographyProps: {
        weight: "bold",
        css: css`
            white-space: nowrap;
        `,
    },
    css: css`
        padding: 0 15px;
        margin-right: 10px;
    `,
    variant: "secondary",
}

actionStyles.overflowMenu= {
    cssOverrides: {
        wrapper: css`
            margin-left: 20px;
            button {
                min-width: 100%;
                &:hover {
                    border: none !important;
                    background: none !important;
                }
                &:focus {
                    outline: none !important;
                }
            }
        `,
    },
}

myListsDetailsOptionsStyles.selectAll= {
    css: css`
        cursor: pointer;
        span[role="checkbox"] {
            border: 2px solid #9e9d9e !important;
            border-radius: 0 !important;
            &:focus {
                box-shadow: none !important;
            }
            &[aria-checked="true"] {
                background: none !important;
                color: ${COLORS.black} !important;
                border: 2px solid ${COLORS.black} !important;
            }
        }
    `,
};

myListsDetailsOptionsStyles.editSortOrder = {
    css: css`
        cursor: pointer;
        margin-left: 30px;
        span[role="checkbox"] {
            border: 2px solid #9e9d9e !important;
            border-radius: 0 !important;
            &:focus {
                box-shadow: none !important;
            }
            &[aria-checked="true"] {
                background: none !important;
                color: ${COLORS.black} !important;
                border: 2px solid ${COLORS.black} !important;
            }
        }
    `,
};

myListsDetailsOptionsStyles.sortByOverflowMenu = {
    iconProps: { src: ChevronsUpDown },
    cssOverrides: {
        wrapper: css`
            margin-left: 20px;
            button {
                min-width: 100%;
                &:hover {
                    border: none !important;
                    background: none !important;
                }
                &:focus {
                    outline: none !important;
                }
            }
        `,
    },
};

myListsEditListFormStyles.cancelButton = {
    mergeCss: true,
    color: "secondary",
    css: css`
        margin-right: 10px;
    `,
};

copyListFormStyles.cancelButton = {
    mergeCss: true,
    color: "secondary",
    css: css`
        margin-right: 10px;
    `,
};

productListLineStyles.selectedCheckbox = {
    sizeVariant: "small",
    css: css`
        @media print {
            display: none;
        }
        margin-right: 10px;
        span[role="checkbox"] {
            border: 2px solid #9e9d9e !important;
            border-radius: 0 !important;
            &:focus {
                box-shadow: none !important;
            }
            &[aria-checked="true"] {
                background: none !important;
                color: ${COLORS.black} !important;
                border: 2px solid ${COLORS.black} !important;
            }
        }
    `,
};

productListLineStyles.addToCartButton = {
    mergeCss: true,
    css: css`
        width: 100%;
    `,
};

productListLineStyles.deleteLink = {
    typographyProps: { size: 16 },
    css: css`
        margin-top: 10px;
    `,
};

productListLineStyles.overflowMenuGridItem = {
    width: [1, 1, 0, 0, 0],
    printWidth: 0,
    css: css`
        button {
            min-width: 100%;
            &:hover {
                border: none !important;
                background: none !important;
            }
            &:focus {
                outline: none !important;
            }
        }
    `,
};

productListStyles.editNotesModalCancelButton = {
    mergeCss: true,
    variant: "secondary",
    css: css`
        margin-left: 10px;
    `,
};

productListStyles.editNotesModalSubmitButton = {
    mergeCss: true,
    css: css`
        margin-left: 10px;
    `,
};
